export const elrBlack = '#081120';
export const elrYellow = '#fccd33';
export const elrGreen = '#054853';
export const elrWhite = '#f3fffd';
export const elrPurple = '#5a4af2';
export const elrGray = '#f7f7f7';
